var map = {
	"./abb-color.svg": 1713,
	"./afb-color.svg": 1714,
	"./afb.svg": 1715,
	"./alb-color.svg": 1716,
	"./alb.svg": 1717,
	"./amb-color.svg": 1718,
	"./amb.svg": 1719,
	"./bbbaidja-color.svg": 1720,
	"./bbbaidjaxxx-color.svg": 1721,
	"./bdinidjaxxx-color.svg": 1722,
	"./bimb-color.svg": 1723,
	"./bimb.svg": 1724,
	"./bkr-color.svg": 1725,
	"./bkr.svg": 1726,
	"./bmriidja-color.svg": 1727,
	"./bniaidja-color.svg": 1728,
	"./bninidja-color.svg": 1729,
	"./bninidjaxxx-color.svg": 1730,
	"./bpay-color.svg": 1731,
	"./brinidja002-color.svg": 1732,
	"./bsmdidjaxxx-color.svg": 1733,
	"./bsn-color.svg": 1734,
	"./bsn.svg": 1735,
	"./btanidjaxxx-color.svg": 1736,
	"./cenaidja-color.svg": 1737,
	"./cenaidjaxxx-color.svg": 1738,
	"./cimb-color.svg": 1739,
	"./cimb.svg": 1740,
	"./citi-color.svg": 1741,
	"./citi.svg": 1742,
	"./default-bank-icon-color.png": 1743,
	"./default-bank-icon.png": 1744,
	"./gxbank-color.svg": 1745,
	"./hlb-color.svg": 1746,
	"./hlb.svg": 1747,
	"./hsbc-color.svg": 1748,
	"./hsbc.svg": 1749,
	"./ibbkidjaxxx-color.svg": 1750,
	"./kwh-color.svg": 1751,
	"./kwh.svg": 1752,
	"./mbb-color.svg": 1753,
	"./mbb.svg": 1754,
	"./nispidjaxxx-color.svg": 1755,
	"./ocbc-color.svg": 1756,
	"./ocbc.svg": 1757,
	"./pbb-color.svg": 1758,
	"./pbb.svg": 1759,
	"./pinbidja-color.svg": 1760,
	"./rhb-b.svg": 1761,
	"./rhb-color-b.svg": 1762,
	"./rhb-color.svg": 1763,
	"./rhb.svg": 1764,
	"./scb-color.svg": 1765,
	"./scb.svg": 1766,
	"./tng-color.svg": 1767,
	"./uob-color.svg": 1768,
	"./uob.svg": 1769
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;